<template>
    <div>
        <!-- modal -->
        <b-modal id="patentInventorFormModal" centered size="lg" no-close-on-backdrop ref="patentInventorFormModal" :title="$t('patentInventor.info')" 
        @close="clear()" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
            <validation-observer ref="infoRules" tag="form">
                <b-row>
                    <b-col class="col-md-12">
                        <b-form>
                            <label for="patentInventor-Name-input">{{ $t('patentInventor.name') }}</label>
                            <b-form-group>
                                <validation-provider #default="{ errors }" :name="$t('patentInventor.name')"
                                    rules="required">
                                    <b-form-input size="sm" id="patentInventor-Name-input" v-model="patentInventorName"
                                        maxlength="100" :state="errors.length > 0 ? false : null" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-md-12">
                        <b-form>
                            <label for="patentInventor-nationalityIDNumber-input">{{ $t('patentInventor.nationality_id_number') }}</label>
                            <b-form-group>
                                <b-form-input size="sm" id="patentInventor-nationalityIDNumber-input" v-model="nationalityIDNumber"
                                    maxlength="11" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-md-12 mb-1">
                        <b-form>
                            <validation-provider :name="$t('patentInventor.country')" #default="{ errors }"
                                :rules="{ excluded: 0 }">
                                <label for="country-input">{{ $t('patentInventor.country') }}</label>
                                <b-form-select v-model="countrySelect" value-field="id" text-field="name" size="sm"
                                    :options="countryOption" />
                                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </validation-provider>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-md-12">
                        <label for="textarea-default">{{ $t('patentInventor.address') }}</label>
                        <validation-provider #default="{ errors }" :name="$t('patentInventor.address')"
                            rules="required">
                            <b-form-textarea size="sm" id="textarea-default" :placeholder="$t('patentInventor.address')"
                                v-model="inventorAddress" rows="2" maxlength="250"
                                :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-col>
                </b-row>
            </validation-observer>
        </b-modal>
    </div>
</template>
 
<script>
export default {
    props: {
        getPatentInventorList: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            patentId:0,
            patentInventorName: '',
            inventorAddress: '',
            countryOption: [],
            countrySelect: 0,
            nationalityIDNumber : 0,
        }
    },
    methods: {
        showInfo(id, patentId) {
            this.$refs['patentInventorFormModal'].show()
            this.id= id
            this.patentId= patentId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'PatentInventor'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.patentInventorName = response.data.patentInventor.name
                    this.inventorAddress = response.data.patentInventor.address
                    this.nationalityIDNumber = response.data.patentInventor.nationalityIDNumber
                    this.countrySelect = response.data.patentInventor.countryId
                    this.countryOption = response.data.countryList
                    this.countryOption.splice(0, 0, this.$nullSelected())
                } else {
                    this.$bvModal.hide('patentInventorFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        clear() {
            this.patentInventorName = null
            this.inventorAddress = null
            this.countrySelect = 0
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                patentId: this.patentId,
                name: this.patentInventorName,
                address: this.inventorAddress,
                countryId: this.countrySelect,
                nationalityIDNumber : this.nationalityIDNumber
            }
            const controller = {
                name: 'PatentInventor'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.infoRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('patentInventorFormModal')
                            this.getPatentInventorList()
                            this.$SaveAlert()
                            this.getPatentList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        }
    },
}
</script>

    
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
